/**
 * RTK Query endpoints — Inspections (list + detail)
 *
 * Migrated from: src/pages/inspections/actions.js
 *
 * The PDF export thunks in `src/pages/inspections/see-inspection/actions.js`
 * stay on the legacy stack — they stream binary and poll for async
 * generation, neither of which benefit from RTK Query's cache.
 */

import { baseApi } from './baseApi';
import { buildQueryString } from './utils';

const inspectionApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    inspectionList: builder.query({
      query: (params = {}) => ({
        url: `/su/control${buildQueryString(params)}`,
        method: 'GET',
      }),
      providesTags: (result) =>
        result?.items
          ? [
              ...result.items.map(({ id }) => ({ type: 'Inspection', id })),
              { type: 'Inspection', id: 'LIST' },
            ]
          : [{ type: 'Inspection', id: 'LIST' }],
    }),

    inspection: builder.query({
      query: (id) => ({ url: `/su/control/${id}`, method: 'GET' }),
      providesTags: (_result, _error, id) => [{ type: 'Inspection', id }],
    }),

    inspectionItems: builder.query({
      query: ({ controlId, ...params }) => ({
        url: `/su/control/${controlId}/items${buildQueryString(params)}`,
        method: 'GET',
      }),
      providesTags: (_result, _error, { controlId }) => [
        { type: 'InspectionItem', id: controlId },
      ],
    }),

    deleteInspection: builder.mutation({
      query: (id) => ({
        url: `/su/control/${id}/delete`,
        method: 'POST',
        body: {},
      }),
      invalidatesTags: (_result, _error, id) => [
        { type: 'Inspection', id },
        { type: 'Inspection', id: 'LIST' },
      ],
    }),
  }),
  overrideExisting: false,
});

export const {
  useInspectionListQuery,
  useInspectionQuery,
  useInspectionItemsQuery,
  useDeleteInspectionMutation,
} = inspectionApi;

export default inspectionApi;
